import routes from './routes'
import store from './store'

export default {
    name: 'm-info',
    store: store,
    routes: routes
}